/* This Source Code Form is subject to the terms of the Mozilla Public
* License, v. 2.0. If a copy of the MPL was not distributed with this
* file, You can obtain one at http://mozilla.org/MPL/2.0/. */

import * as ReactDOM from 'react-dom'
import {Provider} from "react-redux"
import Layout from "./pageLayout"

export function render(element, store) {
    ReactDOM.render(
        <Provider store={store}>
            <Layout/>
        </Provider>,
        element);
}


/** WEBPACK FOOTER **
 ** ./src/renderer.js
 **/